// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_62-6";
export var headerCell = "_62-2";
export var rowWrapper = "_62-4";
export var stickyAggregationCell = "_62-a";
export var stickyAggregationRow = "_62-7";
export var stickyColumnCell = "_62-9";
export var stickyColumnHeaderCell = "_62-8";
export var table = "_62-1";
export var virtualRowWrapper = "_62-5";
export var virtualTableContainer = "_62-0";
export var white = "_62-3";